
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 87.72 87.95"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M76.87 62.62L46 10.24a2.57 2.57 0 00-3.25-.89 2.23 2.23 0 00-1 .89L11 62.49a6.09 6.09 0 00-1.91 4.25c0 8 17.51 12.11 34.83 12.11s34.79-4.16 34.79-12.12a6 6 0 00-1.84-4.11zm-33-46.8L68.74 58c-6.64-2.21-15.74-3.39-24.9-3.39S25.64 55.78 19 58zm0 58.77c-18.24 0-29.91-4.61-30-7.81l1.09-1.86c3.33-2.87 13.88-6.06 28.93-6.06 15.23 0 25.87 3.19 29 6.15l1 1.64v.07c-.02 3.22-11.73 7.87-30.05 7.87z","fill":"#fff","data-name":"Livello 2"}})])
          )
        }
      }
    